import { NgModule } from '@angular/core';
import { PRODUCT_NORMALIZER, PRODUCT_REFERENCES_NORMALIZER } from '@spartacus/core';
import { ProductDocumentsNormalizer } from './product-documents-normalizer';
import { ProductReferencesListNormalizer } from './product-references-list-normalizer';
import { ProductUnitsNormalizer } from './product-units-normalizer';

@NgModule({
  providers: [
    {
      provide: PRODUCT_REFERENCES_NORMALIZER,
      useExisting: ProductReferencesListNormalizer,
      multi: true,
    },
    {
      provide: PRODUCT_NORMALIZER,
      useExisting: ProductDocumentsNormalizer,
      multi: true,
    },
    {
      provide: PRODUCT_NORMALIZER,
      useExisting: ProductUnitsNormalizer,
      multi: true,
    },
  ],
})
export class ProductConvertersModule {}
